// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3820":"967c56dc54843682","7399":"f5ef424147f88ca9"}[chunkId] + ".css";
};